import SentryRepository from './SentryRepository';

export const sentryRepository = new SentryRepository();
